import { HttpClient } from '@angular/common/http';
import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
// import { ThemeService } from '../../../../../../services/theme.service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { ThemeService } from 'vhobjects-service';
// import { FunctionService  } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
import { AtwUpdateDbComponent } from 'vhobjects-service';
// import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-button-preview-admin-config',
  templateUrl: './button-preview-admin-config.component.html',
  styleUrls: ['./button-preview-admin-config.component.scss']
})
export class AtwButtonPreviewAdminConfig  extends AtwUpdateDbComponent  implements OnInit {
@Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() blocks_of_page: any; // là dữ liệu blocks_of_page từ database
  @Input() type: any; // xem đang ở page hay admin

  currentViewAll: any = {}; // biến xác định mở rộng tất cả hay theo thuộc tính
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  valueRange: number = 0; // biến này tính giá trị của (input range / 100) để tính độ trong suốt
  valueParameter: number = 0; // biến này tính giá trị của (input range) để hiện thị giá trị ra màn hình
  style_color: string = '' // biến này lấy giá trị của màu rgb và alpha;

  backgroundColor: any = [];
  typeGradient = [
    {
      type: 'linear-gradient',
      direction: '',
      name: 'Mặc định',
      deg: '180deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to right,',
      name: 'Từ trái sang phải',
      deg: '90deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to left,',
      name: 'Từ phải sang trái',
      deg: '270deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom right,',
      name: 'Từ trái trên sang phải dưới',
      deg: '135deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to bottom left,',
      name: 'Từ phải trên sang trái dưới',
      deg: '225deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top right,',
      name: 'Từ trái dưới sang phải trên',
      deg: '45deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to top left,',
      name: 'Từ phải dưới sang trái trên',
      deg: '315deg',
    },
  ];

  styles_field = [
    {
      title: 'dieu_chinh_noi_dung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien',
      index: 2,
    },
    {
      title: 'hieu_ung',
      index: 3,
    },
    {
      title: 'nang_cao',
      index: 4,
    },
  ];
  effect_hover = [];
  effect_hover_data: any = {}
  width = 0;
  height = 0;
  configMode: 'basic' | 'advanced' = 'basic';


  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
    public themeService: ThemeService,
    @Inject(PLATFORM_ID) private platformId: Object,
    public functionService: FunctionService,
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
   }

  ngOnInit(): void {
  // phần này get dữ liệu json
  forkJoin([
    this.http.get('assets/data/effects/button.json'),
    this.http.get('assets/background-colors/background-colors.json'),
  ]).subscribe(([effects, background_colors,]: any) => {
    this.effect_hover = effects;
    this.backgroundColor = background_colors;
    this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
  })
}

    /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }


  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true, menu2: false, menu3: false, menu4: false, menu5: false, menu6: false, menu7: false, menu8: false
  };
  openMapSub: { [name: string]: boolean } = {
    submenu1: true, submenu2: false
  };

  openHandler(value: string, isSub = false): void {
    const targetMap = isSub ? this.openMapSub : this.openMap;
    Object.keys(targetMap).forEach(key => {
      if (key !== value) targetMap[key] = false;
    });
  }


  parserPercent = (value: string): string => value.replace('%', '');
  formatterPercent = (value: number): string => {
    return `${value} %`;
  };



  ngOnChanges(changes: SimpleChanges): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
    setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        this.width = document.getElementById(this.objectChoosing._id).clientWidth;
        this.height = document.getElementById(this.objectChoosing._id).clientHeight;
      }
    }, 0);
  }

  // hàm cập nhật background linear-gradient
  updateBackgroundRgb() {
    if (this.config['background-color'].gradient_check) {
      this.class['button']['background-image'] = "linear-gradient(" + this.config['background-color']['gradient_direction'] + this.config['background-color']['gradient_arr'] + ")";
    }
    else {
      this.class['button']['background-image'] = "none";
    }
    this.updateObject();
  }
  /**
   * Hàm update object vào database.
   */
  // updateObject() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
  //     .then((bool: any) => {
  //       // console.log('updateObject', bool);
  //     })
  // }
  /**
   *Hàm update class vào database.
   */
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //     .then((bool: any) => {
  //       // console.log('updateClass', bool);
  //     })
  // }



  /**
   * hàm này để update width height trong dimention của config  
   */
  updateDimension() {
    if (isPlatformBrowser(this.platformId)) {
      this.width = document.getElementById(this.objectChoosing._id).clientWidth;
      this.height = document.getElementById(this.objectChoosing._id).clientHeight;
    }
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.config = {
      ...this.config,
      dimension: {
        width: Number(Number(this.width).toFixed(2)),
        height: Number(Number(this.height).toFixed(2))
      }
    }

    this.updateConfig()
  }
  /**
   *Hàm update config vào database.
   */
  // updateConfig() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
  //     .then((bool: any) => {
  //     })
  // }


  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    if (this.type == 'admin') {
            if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing)
      if (!this.objectChoosing['fieldUpdate'].includes('staticdata')) this.objectChoosing['fieldUpdate'].push('staticdata')
      this.updateDimension()
      return;
    }
    // Gọi hàm truy vấn cơ sở dữ liệu ở đây
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
      });
    this.updateDimension()
  }

  /**
   * remove link khi click vào nút x
   */
  removeLink() {
    this.staticdata.hyper_link = '';
    this.updateStaticData();
  }
  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /**Xử lý lấy thông số giá trị background color.
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundColor(e) {
    // lấy giá trị tham số event của thanh slide khi thay đổi.
    this.valueParameter = e.target.value;
    // Tính giá trị alpha cho màu rgb.
    const data = this.class['button']
    // Nối chuỗi màu + độ mờ (alpha) và lưu vào database.
    this.style_color = `rgba(${this.hexToRGB(data.background)}, ${this.config['background-color']['value_range'] / 100
      })`;
    data.background_rgb = this.style_color;
    this.updateClass();
  }
  /**Xử lý lấy thông số giá trị background gradient
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundGradient(e) {
    // lấy giá trị tham số event của thanh slide khi thay đổi.
    this.valueParameter = e.target.value;
    if (this.device == 'desktop') {
      // Tính giá trị alpha cho màu rgb.
      this.config['background-color']['value_parameter'] =
        this.valueParameter;
      this.config['background-color']['value_range'] =
        this.valueParameter / 100;
      // Tách các phần tử màu từ chuỗi rgba.
      const newArr =
        this.config['background-color'].gradient_arr.map(
          (color) => {
            const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
            return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-color']['value_range']})`;
          }
        );
      // return giá trị chuỗi màu gradient và lưu vào database.
      this.config['background-color'].gradient_arr = newArr;
      this.updateBackgroundRgb()
    } else {
      // Tính giá trị alpha cho màu rgb.
      this.config['background-color']['value_parameter'] =
        this.valueParameter;
      this.config['background-color']['value_range'] =
        this.valueParameter / 100;
      const newArr =
        this.config['background-color'].gradient_arr.map(
          (color) => {
            // Tách các phần tử màu từ chuỗi rgba
            const parts = color.match(/(\d+(\.\d+)?)/g);
            return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-color']['value_range']})`;
          }
        );
      // return giá trị chuỗi màu gradient và lưu vào database.
      this.config['background-color'].gradient_arr = newArr;
      this.updateClass()
    }
  }
  /** Hàm này lấy giá trị màu nền của input color
  * @param event : trả về màu được chọn từ input color
  */
  updateColorInput(e) {
    const value_color = e.target.value;
    const data_desktop = this.class['button'];
    const data_mobile = this.class['button'];
    // Chuyển đổi chuổi màu hexadecimal thành rgb
    // Nối chuỗi rgb + giá trị alpha và cập nhật lưu vào database.
    this.style_color = `rgba(${this.hexToRGB(value_color)}, ${this.config['background-color']['value_range']
      })`;
    data_desktop.background_rgb = this.style_color;
    this.updateClass();
  }
  /**Hàm này dùng để click chọn màu nền của danh sách màu.
   * @param bgColor : trả về màu được chọn
   * @param event : trả về element được active
   */
  chooseBg(bgColor, event) {
    if (isPlatformBrowser(this.platformId)) {
      // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
      // Lấy ra element màu được click từ tham số event trả về.
      var activeGradient = document.querySelector(
        '.container-color .active'
      ) as HTMLElement;
      if (activeGradient) activeGradient.classList.remove('active');
      event.currentTarget.classList.add('active');
      // Lấy giá trị màu được click từ tham số bgColor.
      //  Chuyển đổi màu được click thành mã rgb , thêm alpha vào mã rgb và lưu vào database.
      const data_background = this.class['button']
      data_background['background-color'] = bgColor.bgColor;
      data_background['background-color'] = `rgba(${this.hexToRGB(data_background['background-color'])}, ${this.config['background-color'].value_range})`;
      this.updateObject();
    }
  }
  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    if (isPlatformBrowser(this.platformId)) {
      // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
      this.config['background-color'].gradient_type = direction.type;
      this.config['background-color'].gradient_direction = direction.direction;
      this.class['button']['background-image'] = this.config['background-color'].gradient_type + '(' + this.config['background-color'].gradient_direction + this.config['background-color'].gradient_arr.join(',') + ')'
      this.updateConfig();
      this.updateClass();
    }
  }

  customize = []
  /** Xử lý border
  */
  toggleBorder(isActive) {
    const active = this.class['button'];
    active.check_border = isActive;
    active.check_border_top = isActive;
    active.check_border_bottom = isActive;
    active.check_border_right = isActive;
    active.check_border_left = isActive;
    this.updateClass();
  }

  openbgGradient() {
    if (isPlatformBrowser(this.platformId)) document.getElementById('input-gradient').click();
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value) {
    if (/\#/.test(value)) {
      const gradient =
        this.device == 'desktop'
          ? this.config['background-color']
          : this.config['background-color'];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.value_range})`
      );
      this.updateBackgroundRgb();
    }
  }
  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index) {
    if (this.config['background-color'][`gradient_arr`].length > 1) {
      this.config['background-color'][`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb()
    }
  }
 

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi.
   * 
   * Nếu là text-align: left thì padding-left là phần configPaddingLeftRight, padding-right sẽ nhận toàn bộ phần padding còn lại, trừ đi configPaddingLeftRight; tương tự với trường hợp text-align: right.
   * Đối với text-align: center thì là padding / 2
   */
  changeWidthHeight(event) {
    //Vì thay đổi kích thước width, height của button chính là thay đổi giá trị padding, còn các giá trị khác như kích thước nội dung chữ, kích thước border... ko thay đôi,
    //do đó ta chỉ tính lại giá trị padding mới theo khoảng giá trị thay đổi của width, height
    if (event.width) {
      const paddingLeft = Number(this.class['button']['padding-left'].toString().match(/\d+(\.\d+)?/g).join(""));
      const paddingRight = Number(this.class['button']['padding-right'].toString().match(/\d+(\.\d+)?/g).join(""));
      const widthDifference = event.width - this.width;
      const configPaddingLeftRight = this.config['padding'];

      switch (this.class['button__content']['text-align']) {
        case 'left':
          this.class['button']['padding-left'] = configPaddingLeftRight + 'px';
          this.class['button']['padding-right'] = paddingLeft + paddingRight + widthDifference - configPaddingLeftRight + 'px';
          break;
        case 'right':
          this.class['button']['padding-right'] = configPaddingLeftRight + 'px';
          this.class['button']['padding-left'] = paddingLeft + paddingRight + widthDifference - configPaddingLeftRight + 'px';
          break;
        default:
          this.class['button']['padding-left'] = (paddingLeft + paddingRight + widthDifference) / 2 + 'px';
          this.class['button']['padding-right'] = (paddingLeft + paddingRight + widthDifference) / 2 + 'px';
          break;
      }

      if(document.getElementById(this.objectChoosing._id).clientWidth > event.width) {
        this.changeWidthHeight({width: document.getElementById(this.objectChoosing._id).clientWidth})
      }
    }
    if (event.height) {
      this.class['button']['padding-top'] = Number(this.class['button']['padding-top'].toString().match(/\d+(\.\d+)?/g).join("")) + (event.height - this.height) / 2 + 'px';
      this.class['button']['padding-bottom'] = Number(this.class['button']['padding-bottom'].toString().match(/\d+(\.\d+)?/g).join("")) + (event.height - this.height) / 2 + 'px';
      if(document.getElementById(this.objectChoosing._id).clientHeight > event.height) {
        this.changeWidthHeight({height: document.getElementById(this.objectChoosing._id).clientHeight})
      }
    }
    this.updateClassAndWidthHeight();
  }

    /**
  *Hàm update class vào dabase, và gửi cập nhật width, height cho object-selected
  */
  updateClassAndWidthHeight() {
    if (isPlatformBrowser(this.platformId)) {
      this.width = document.getElementById(this.objectChoosing._id).clientWidth;
      this.height = document.getElementById(this.objectChoosing._id).clientHeight;
    }
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    if (this.type == 'admin') {
            if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing)
      if (!this.objectChoosing['fieldUpdate'].includes(this.device+'_class')) this.objectChoosing['fieldUpdate'].push(this.device+'_class')
      return;
    }
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        // console.log('updateClassAndWidthHeight', bool);
      })
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[2])
  }
}
